import { createSlice } from '@reduxjs/toolkit';
import getInitialState, {
    MODAL_STATUS
} from 'tradera-state/views/checkout/initial-state';

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState: getInitialState(),
    reducers: {
        receiveCheckout: (state, { payload }) => {
            const {
                buyerMember,
                purchaseOrder,
                sellerMember,
                shippingOptions
            } = payload;
            state.buyerMember = { ...buyerMember };
            state.sellerMember = { ...sellerMember };
            state.items = purchaseOrder.items;
            state.shippingOptions = shippingOptions;
            state.isFetching = false;
            state.hasError = false;
            state.purchaseOrderId = purchaseOrder.purchaseOrderId;
            state.isPaid = purchaseOrder.isPaid;
        },
        receivePaymentOptions: (state, { payload }) => {
            const { paymentOptions } = payload;
            state.payment.paymentOptions = paymentOptions;
            state.payment.isFetching = false;
        },
        setCheckoutSummary: (state, { payload }) => {
            state.checkoutSummary = {
                ...payload,
                isFetching: false,
                hasError: false
            };
        },
        setFetching: (state, { payload }) => {
            state.isFetching = payload;
            state.hasError = false;
        },
        openModal: (state, { payload }) => {
            const { open, status, paymentAttemptId } = payload;
            state.modal = {
                open,
                status,
                paymentAttemptId
            };
        },
        cancelPayment: state => {
            state.checkoutSummary.hasError = false;
            state.checkoutSummary.isFetching = false;
            state.showDisableOverlay = false;
        },
        closeModal: state => {
            state.modal = {
                open: '',
                status: MODAL_STATUS.START
            };
        },
        setHasError: (state, { payload }) => {
            state.hasError = payload;
            state.isFetching = false;
            state.showDisableOverlay = false;
        },
        setPaymentFetching: (state, { payload }) => {
            state.payment.isFetching = payload;
            state.payment.hasError = false;
        },
        setPaymentHasError: (state, { payload }) => {
            state.payment.hasError = payload;
            state.payment.isFetching = false;
            state.showDisableOverlay = false;
        },
        setPaymentMethodData: (state, { payload }) => {
            state.payment.paymentMethodData = payload;
        },
        setCheckoutSummaryFetching: (state, { payload }) => {
            state.checkoutSummary.isFetching = payload;
            state.checkoutSummary.hasError = false;
        },
        setCheckoutSummaryHasError: (state, { payload }) => {
            state.checkoutSummary.hasError = payload;
            state.checkoutSummary.isFetching = false;
            state.showDisableOverlay = false;
            state.modal.status = MODAL_STATUS.ERROR;
        },
        setSelectedPayment: (state, { payload }) => {
            state.payment.selectedPayment = payload;
            state.payment.paymentMethodData = null;
        },
        setSelectedShipping: (state, { payload }) => {
            state.selectedShipping = payload;
        },
        setShowDisalbeOverlay: (state, { payload }) => {
            state.showDisableOverlay = payload;
        }
    }
});

export const {
    openModal,
    closeModal,
    cancelPayment,
    receiveCheckout,
    receivePaymentOptions,
    setCheckoutSummary,
    setFetching,
    setHasError,
    setCheckoutSummaryFetching,
    setCheckoutSummaryHasError,
    setPaymentFetching,
    setPaymentHasError,
    setPaymentMethodData,
    setSelectedPayment,
    setSelectedShipping,
    setShowDisalbeOverlay
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
